// Libs
import React from 'react'
import { NavLink } from 'react-router-dom'

// CSS
import './styles.scss'

const Breadcrumb = ({ marginBottom, routes }) => {
  const routesLength = routes.length
  let path = ''

  const addAccents = (word) => {
    switch (word) {
      case 'analise':
        return 'análise'
      case 'negociacao':
        return 'negociação'
      case 'finalizacao':
        return 'finalização'
      default:
        return word
    }
  }

  const breadcrumbRoutes =
    routes
      .reduce(function (a, b, index) {
        // Create path
        path += '/' + b
        // Remove hyphen from routes
        const bWithoutHyphen = b?.replace(/-/g, " ")
        // If routes array length bigger than 1
        if (routesLength > 1) {
          // If isn't the first index
          if (index === routesLength - 1) {
            // Return this li
            return [...a, <li key={b} className="breadcrumb__route">{addAccents(bWithoutHyphen)}</li>]
          }
          // If is the first index
          // Return this li with a link child
          return [<li key={b} className="breadcrumb__route">
            <a href={path} className="breadcrumb__link">{addAccents(bWithoutHyphen)} / </a>
          </li>]
        }
        // If routes array length less than 1
        // Return this li
        return <li key={b} className="breadcrumb__route">{addAccents(bWithoutHyphen)}</li>
      }, {})

  return (
    <ul style={{ marginBottom: `${marginBottom}px` }} className="breadcrumb">
      {breadcrumbRoutes}
    </ul>
  )
}

export default Breadcrumb
